import { UserName } from "./UserName.js";
import { useUser } from "../hooks/useUser.js";
import { UserAvatar } from "./UserAvatar.js";
import "react";
import { Skeleton } from "@therms/atalaya";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
//#region src/modules/Users/shared/UserBadgeWide.tsx
function Render({ className, size = "base", user }) {
	const avatarSize = size === "md" ? "lg" : size === "sm" ? "xs" : "base";
	return /* @__PURE__ */ jsxs("div", {
		className: classnames(className, "gap-x-sm gap-y-xxs flex items-center"),
		children: [!!user.avatarUrl && /* @__PURE__ */ jsx(UserAvatar, {
			statusVariant: user.connected ? "positive" : void 0,
			size: avatarSize,
			user: { avatarUrl: user.avatarUrl }
		}), /* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx("div", {
			className: classnames({
				"text-md": size === "md",
				"text-sm": size === "sm"
			}, "text-color-strong font-medium"),
			children: /* @__PURE__ */ jsx(UserName, {
				user,
				showId: false,
				truncate: true
			})
		}), /* @__PURE__ */ jsxs("div", { children: [!!user.idNumber && /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx("span", {
			className: "bg-border rounded px-[2px] text-xs font-medium",
			children: user.idNumber
		}), " "] }), /* @__PURE__ */ jsx("span", {
			className: size === "sm" ? "text-xs" : "text-sm",
			children: user.title
		})] })] })]
	});
}
function UserBadgeWideFromId({ className, size, userId }) {
	const { data, loading } = useUser({ userId }, { cacheStrategy: "cache-only" });
	if (!data?.user || loading) return /* @__PURE__ */ jsx(Skeleton, {
		height: "45px",
		width: "300px"
	});
	return /* @__PURE__ */ jsx(Render, {
		className,
		size,
		user: data.user
	});
}
function UserBadgeWide({ className, size, user, userId }) {
	if (user) return /* @__PURE__ */ jsx(Render, {
		className,
		size,
		user
	});
	if (userId) return /* @__PURE__ */ jsx(UserBadgeWideFromId, {
		className,
		size,
		userId
	});
	return null;
}
//#endregion
export { UserBadgeWide };

//# sourceMappingURL=UserBadgeWide.js.map